<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default
{
    name: 'mv-menu-entry',

    props:
    {
        model: null,
        submenu: Boolean,
    },

    computed: {
      ...mapGetters({ locale: 'generalCurrentLocale'}),

      routes()
      {
          return [
              {
                  name: 'Üres',
                  value: null,
              },
              {
                  name: 'Fő oldal',
                  value: 'home',
              },
              {
                  name: 'Oldal',
                  value: 'page-direct',
                  params: [
                      {
                        name: 'target',
                        values: this.pages.map(el => el.slug),
                      }
                  ]
              },
              {
                  name: 'Szolgáltatások',
                  value: 'services',
                  params: [
                      {
                          name: 'categoryName',
                          values: ['utazas', 'szallas'],
                      }
                  ]
              },
              {
                  name: 'Info oldal',
                  value: 'info',
              },
              {
                  name: 'Helyszínek',
                  value: 'maps',
                  params: [
                    {
                        name: 'type',
                        values: [null, 'google', 'graphical'],
                    }
                  ]
              },
              {
                  name: 'Jegyek',
                  value: 'ticket',
              },
              {
                  name: 'Szállás',
                  value: 'accomodation',
              },
              {
                  name: 'Hírek',
                  value: 'news',
              },
              {
                  name: 'Sajtóanyagok',
                  value: 'press',
              },
              {
                  name: 'Űrlapok',
                  value: 'forms',
              },
              {
                  name: 'Programok',
                  value: 'programs',
              }

          ]
      },

      blocks() {
        return [
          {
            name: 'Bal oldal',
            value: 'left'
          },
          {
            name: 'Jobb oldal',
            value: 'right'
          },
        ]
      },

      currentRoute()
      {
          if (!this.model.is_external)
            return this.routes.find(el => el.value == this.model.to)
          return undefined;
      },

      currentBlock()
      {
          return this.blocks.find(el => el.value == this.model.block)
      }

    },

    methods:
    {
        toggle()
        {
            this.isOpen = !this.isOpen
        },

        save()
        {
            if (this.model.id)
            {
                this.$api('put', `/v1/admin/sitemenus/${this.model.id}`, this.model).then(res => { this.$emit('fetch') })
            } else {
                this.$api('post', `/v1/admin/sitemenus`, this.model).then(res => {
                    this.$emit('fetch')
                })
            }
        },

        create()
        {
            this.model.children.push({
                parent_id: this.model.id,
                is_active: false,
                order: 99,
                name: this.$t('GENERAL.NEW'),
                name_en: null,
                type: 'TOP',
                is_external: false,
                is_new_tab: false,
                href: null,
                to: null,
                params: {},
            })
            this.isOpen = true
        },

        trash()
        {
            if (this.model.id)
            {
                this.$snotify.confirm(this.$t('GENERAL.DELETE_MODEL', { model: this.model.name }), this.$t('GENERAL.DELETE'), {
                    buttons: [
                        {text: this.$t('GENERAL.YES'), action: (toast) => {
                            this.$snotify.remove(toast.id)
                            this.$api('delete',  `/v1/admin/sitemenus/${this.model.id}`, {}, {
                                title: '',
                                body: this.$t('GENERAL.DELETING'),
                                success: this.$t('GENERAL.DELETED'),
                            }).then(() => {
                                this.$emit('fetch')
                            }).catch((e) => {})
                        }, bold: false},
                        {text: this.$t('GENERAL.NO'), action: (toast) => this.$snotify.remove(toast.id) },
                    ]
                })
            } else {

            }
        },

        setType(evt)
        {
            const type = evt.target.value
            if (type && type != '')
            {
                this.model.type = type
            }
        },

        setTo(evt)
        {
            const to = evt.target.value
            this.model.to = to
        },

        setParam(name, evt)
        {
            const param = evt.target.value
            if (this.model.params instanceof Object || this.model.params instanceof Array)
              this.model.params = {}
            this.$set(this.model.params, name, param)
        }


    },

    data()
    {
        return {
            pages: [],
            isOpen: false,
            types: [
              {
                name: 'Fejléc',
                value: 'TOP',
              },
              {
                name: 'Lábléc',
                value: 'BOTTOM',
              },
            ],
        }
    },

    mounted()
    {
        axios.get(`${process.env.API_URL}/v1/admin/posts`, { params: { type: 'site'}}).then(res => {
            this.pages = res.data
        })
    }
}
</script>

<template>
<div>
    <div class="panel panel-primary">
        <div class="panel-heading clickable" @click="toggle">
            <div class="row">
                <div class="col-sm-10" :class="{'text-danger': !model.is_active}">
                    <h4>{{ model.order }}. {{ model.name }} </h4>
                </div>
                <div class="col-sm-2 text-right">
                    <button class="btn btn-xs btn-success" @click.stop.prevent="create" v-if="model.id">
                        <icon name="plus"></icon>
                    </button>
                    <button class="btn btn-xs btn-warning" @click.stop.prevent="trash" v-if="model.id">
                        <icon name="trash"></icon>
                    </button>
                </div>
            </div>
        </div>
        <transition name="fade">
            <div class="panel-body" v-show="isOpen">
                <form @submit.prevent.stop="save">
                    <div class="form-group row">
                        <label for="name" class="col-md-4 control-label">
                            {{ $t('MENUS.NAME') }}
                        </label>
                        <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="input-group">
                                  <span class="input-group-addon" id="basic-addon1">
                                    <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                                  </span>
                                  <input type="text" class="form-control" v-model="model.name">
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="input-group">
                                  <span class="input-group-addon" id="basic-addon2">
                                    <img src="/static/us-flag.png" alt="English" title="English" height="20">
                                  </span>
                                  <input type="text" class="form-control" v-model="model.name_en">
                                </div>
                              </div>
                            </div>
                        </div>
                        <div class="col-md-2" style="margin-top: .4em;">
                            <label for="active" class="control-label">
                                <input type="checkbox" v-model="model.is_active" >
                                {{ $t('MENUS.ACTIVE') }}
                            </label>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="color" class="col-md-4 control-label">
                            {{ $t('MENUS.TYPE') }}
                        </label>
                        <div class="col-md-6">
                            <select class="form-control" @change="setType($event)">
                                <option v-for="type in types" :key="type.name" :value="type.value" :selected="model.type == type.value">{{ type.name }}</option>
                            </select>
                        </div>
                        <div class="col-md-2" style="margin-top: .4em;">
                            <label for="active" class="control-label">
                                <input type="checkbox" v-model="model.is_external" >
                                {{ $t('MENUS.IS_EXTERNAL') }}
                            </label>
                        </div>
                    </div>

                    <div class="form-group row" v-if="model.is_external">
                        <label for="link" class="col-md-4 control-label">
                            {{ $t('MENUS.LINK') }}
                        </label>
                        <div class="col-md-6">
                            <input type="text" class="form-control" v-model="model.href" placeholder="https://" >
                        </div>
                        <div class="col-md-2" style="margin-top: .4em;">
                            <label for="active" class="control-label">
                                <input type="checkbox" v-model="model.is_new_tab" >
                                {{ $t('MENUS.IS_NEW_TAB') }}
                            </label>
                        </div>
                    </div>

                    <div class="form-group row" v-if="!model.is_external">
                        <label for="link" class="col-md-4 control-label">
                            {{ $t('MENUS.LINK') }}
                        </label>
                        <div class="col-md-6">
                            <select class="form-control" @change="setTo($event)">
                                <option v-for="route in routes" :key="route.name" :value="route.value" :selected="model.to == route.value">{{ route.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row" v-if="model.type == 'BOTTOM'">
                        <label for="link" class="col-md-4 control-label">
                            {{ $t('MENUS.BLOCK') }}
                        </label>
                        <div class="col-md-6">
                            <select class="form-control" v-model="model.block">
                                <option v-for="block in blocks" :key="block.value" :value="block.value" :selected="model.block == block.value">{{ block.name }}</option>
                            </select>
                        </div>
                    </div>

                    <div class="form-group row" v-if="!model.is_external && currentRoute && currentRoute.params && currentRoute.params.length">
                        <label for="link" class="col-md-4 control-label">
                            {{ $t('MENUS.PARAMS') }}
                        </label>
                        <div class="col-md-6">
                          <div class="row" v-for="param in currentRoute.params">
                            <label for="link" class="col-md-4 control-label" style="margin-top: .4em;">
                                {{ param.name }}
                            </label>
                            <div class="col-md-6">
                                <select class="form-control" :value="model.params[param.name]" @change="setParam(param.name, $event)">
                                    <option v-for="val in param.values" :key="val" :value="val">{{ val }}</option>
                                </select>
                            </div>
                          </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="order" class="col-md-4 control-label">
                            {{ $t('MENUS.ORDER') }}
                        </label>
                        <div class="col-md-6">
                            <input type="number" class="form-control" v-model="model.order" >
                        </div>
                    </div>

                    <div class="form-group row">
                        <div class="col-md-12 text-right">
                            <button class="btn btn-success">{{ $t('GENERAL.SAVE') }}</button>
                        </div>
                    </div>
                </form>

                <mv-menu-entry v-for="item in model.children" :key="item.id" :model="item" @fetch="$emit('fetch')" submenu />
            </div>
        </transition>
    </div>
</div>
</template>



// WEBPACK FOOTER //
// src/components/MenuEntry.vue